var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistoryLf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5528_245246)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5528_245246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.71783 14.2197C1.01072 13.9268 1.4856 13.9268 1.77849 14.2197L4.49816 16.9393L7.21782 14.2197C7.51071 13.9268 7.98559 13.9268 8.27848 14.2197C8.57137 14.5126 8.57137 14.9874 8.27848 15.2803L5.02849 18.5303C4.73559 18.8232 4.26072 18.8232 3.96783 18.5303L0.71783 15.2803C0.424937 14.9874 0.424937 14.5126 0.71783 14.2197Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05224 7.26901C6.18781 5.76158 7.78253 4.66404 9.59611 4.14175C11.4097 3.61946 13.3439 3.70073 15.1073 4.37329C16.8707 5.04586 18.3677 6.2733 19.3728 7.87066C20.378 9.46803 20.8367 11.3488 20.68 13.2296C20.5233 15.1103 19.7596 16.8892 18.504 18.2982C17.2483 19.7072 15.5688 20.67 13.7184 21.0414C11.8681 21.4129 9.94709 21.1729 8.24495 20.3577C7.87137 20.1788 7.71358 19.7309 7.8925 19.3573C8.07142 18.9837 8.51931 18.8259 8.89289 19.0049C10.3017 19.6796 11.8917 19.8782 13.4232 19.5708C14.9547 19.2633 16.3449 18.4665 17.3841 17.3003C18.4234 16.1341 19.0555 14.6617 19.1852 13.105C19.3149 11.5483 18.9352 9.99165 18.1033 8.66953C17.2713 7.34742 16.0323 6.33149 14.5727 5.77481C13.1132 5.21814 11.5123 5.15088 10.0112 5.58317C8.51015 6.01546 7.19023 6.92388 6.25033 8.17155C5.31709 9.4104 4.80871 10.9171 4.80027 12.4675L5.24714 17.4328C5.28427 17.8453 4.97994 18.2099 4.56739 18.247C4.15484 18.2841 3.79031 17.9798 3.75318 17.5673L3.30318 12.5672C3.30115 12.5447 3.30014 12.522 3.30016 12.4994C3.30176 10.6121 3.91667 8.77644 5.05224 7.26901Z",
    fill: "#404349"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.75C12.4142 7.75 12.75 8.08579 12.75 8.5V12.4802L16.2633 13.7978C16.6512 13.9432 16.8477 14.3755 16.7022 14.7633C16.5568 15.1512 16.1245 15.3477 15.7367 15.2022L11.7367 13.7022C11.4439 13.5925 11.25 13.3126 11.25 13V8.5C11.25 8.08579 11.5858 7.75 12 7.75Z",
    fill: "#404349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5528_245246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5528_245246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2132,
    height: 21.2132,
    fill: "white",
    transform: "translate(-3 12.5) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLf);
export default __webpack_public_path__ + "static/media/historyLF.96adf8478d09338458be86f0a0205cfd.svg";
export { ForwardRef as ReactComponent };